export enum StorageKeys {
    lsLang = "lsAvoLang",
    lsWasLoggedIn = "lsAvoWasLoggedIn",
    lsCookies = "lsAvoCookies",
    affiliate = "affiliate",
    depositSource = "lsDepositSource",
}
